import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http"
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
//import { DndModule } from 'ng2-dnd';
//TODO: Uncomment the line below when DndModule is available
//import { DndModule } from 'ngx-drag-drop';

import { ClipboardModule } from "ngx-clipboard";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { AboutModule } from './about/about.module';
import { HomeModule } from './home/home.module';
import { JobsModule } from './jobs/jobs.module';
import { SharedModule } from './shared/shared.module';
import { JobDetailsModule } from "./jobDetails/jobDetails.module";
import { RequestModule } from './request/request.module';
import { SigningModule } from "./signing/signing.module";
import { NewJobModule } from "./newJob/newJob.module";
import { AccountModule } from "./account/account.module";
import { UpgradeModule } from "./upgrade/upgrade.module";
import { SubscriptionModule } from "./subscription/subscription.module";
import { DeleteConfirmModule } from "./deleteConfirm/delete-confirm.module";
import { PaymentModule } from "./payment/payment.module";
import { ResultModule } from "./result/result.module";
import { CombineModule } from "./combine/combine.module";
import { SharingModule } from "./sharing/sharing.module";
import { ViewModule } from "./view/view.module";
import { ValidateModule } from "./validate/validate.module";
import { PrepareModule } from "./prepare/prepare.module";
import { PrepareSelfModule } from "./prepareSelf/prepare-self.module";
import { DocRequestModule } from "./docRequest/docRequest.module";
import { FormDesignerModule } from "./formDesigner/form-designer.module";
import { MultiSigningModule } from "./multisigning/multisigning.module";
import { FromDriveModule } from "./fromDrive/fromDrive.module";
import { AuthGluuModule } from "./authgluu/authgluu.module";
import {SigningCadesModule} from "./signingCades/signing-cades.module";
import { ApiModule, Configuration } from './communication';
import { DashboardComponent } from '@uppy/angular';
//import { UppyAngularDragDropModule } from '@uppy/drag-drop';
import {Config} from "../environments/environment";




// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        ClipboardModule,
        //TODO: Uncomment the line below when DndModule is available
        //DndModule.forRoot(),
        RouterModule.forRoot(routes, {}),
        DashboardComponent,
        FormsModule,
        ReactiveFormsModule,
        AboutModule,
        HomeModule,
        JobsModule,
        JobDetailsModule,
        NewJobModule,
        AccountModule,
        SharingModule,
        PrepareModule,
        FormDesignerModule,
        SharedModule.forRoot(),
        PdfViewerModule,
        RequestModule,
        PrepareSelfModule,
        CombineModule,
        DocRequestModule,
        FromDriveModule,
        MultiSigningModule,
        PaymentModule,
        ResultModule,
        SigningModule,
        SigningCadesModule,
        SubscriptionModule,
        DeleteConfirmModule,
        UpgradeModule,
        ValidateModule,
        ViewModule,
        AuthGluuModule,

        ApiModule.forRoot(() => new Configuration({ basePath: Config.WEBSERVICEURL })),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
